/**
 * @enum {string}
 * MeasurementVolume planHeight type.
 */
const VolumePlanHeightType = {
  /**
   * @type {string}
   * @constant
   */
  MIN: "min",
  /**
   * @type {string}
   * @constant
   */
  MAX: "max",
  /**
   * @type {string}
   * @constant
   */
  AVERAGE: "average",
};

export default Object.freeze(VolumePlanHeightType);
